import { render, staticRenderFns } from "./FeedDelivery.vue?vue&type=template&id=0ec88b70"
import script from "./FeedDelivery.vue?vue&type=script&lang=ts"
export * from "./FeedDelivery.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports